// extracted by mini-css-extract-plugin
export default {"card":"xQ","cardrow":"yQ","cardcentered":"zQ","details":"AQ","imgwrapper":"BQ","img":"CQ","category":"EQ","name":"FQ","copy":"GQ","detailsbtn":"HQ","remove":"IQ","price":"JQ","netPrice":"KQ","regularPrice":"LQ","label":"MQ"};
    if(module.hot) {
      // 1711717534313
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  